import { RootScopeEvents } from '../../../common/services/root-scope-types';
import { actions as coreActions, getAngularService, localeService, ToastType, AngularServices, canUseBackgroundEffects, } from '../../core';
import * as devices from '../../../modules/devices';
import { extensionIntegrEvents } from '../../../modules/extensions-framework/angular-integration/integration-types';
import { VISIBLE_PARTICIPANTS_COUNT } from '../../call-mobile/constants';
import { BrandedVirtualBackground, getEffectsWithBrandedVirtualBackground, } from '../constants';
import * as helpers from '../helpers';
import { getIsCaptionsOpen, setIsClosedCaptionsOpen, clearCaptions, } from '../../captions';
import { getLocalStorage, getLocalStorageValueForCurrentUser, LocalStorageKeys, setLocalStorage, setLocalStorageValueForCurrentUser, } from '../../../utility/local-storage';
import { getCurrentStreamId } from '../selectors';
import TokboxMediaStream from '../../../providers/video/tokbox/lib/streams/media-stream';
import { getIsLogoHorizontalDefault } from '../components/background-effects/helpers';
export const hideSurvey = () => () => {
    const callQualitySurveyService = getAngularService(AngularServices.CallQualitySurveyService);
    callQualitySurveyService.hide();
};
export const hideSurveyDelayed = () => () => {
    const callQualitySurveyService = getAngularService(AngularServices.CallQualitySurveyService);
    callQualitySurveyService.hideDelayed();
};
export const submitRating = ({ rating, data, comment, isProviderFeedback, }) => () => {
    const rootScope = getAngularService(AngularServices.RootScope);
    rootScope.$emit(RootScopeEvents.VIDEO_CHAT.USER_CALL_RATING, {
        rating,
        data,
        comment,
        isProviderFeedback,
    });
};
export const setActiveStreamId = (streamId) => (dispatch) => {
    dispatch({ type: 'CALL/SET_ACTIVE_STREAM_ID', payload: streamId });
};
export const setCurrentStreamId = (streamId) => (dispatch) => {
    dispatch({ type: 'CALL/SET_CURRENT_STREAM_ID', payload: streamId });
};
export const setPinnedStreamId = (streamId) => (dispatch) => {
    dispatch({ type: 'CALL/SET_PINNED_STREAM_ID', payload: streamId });
};
export const setConnectionStatus = (connectionInfo) => (dispatch) => {
    dispatch({
        type: 'CALL/SET_PARTICIPANTS_CONNECTION_STATUS',
        payload: connectionInfo,
    });
};
export const updateParticipant = (id, participant) => (dispatch) => {
    dispatch({
        type: 'CALL/UPDATE_PARTICIPANT',
        payload: { id, data: participant },
    });
};
export const setSelfParticipant = (participant) => (dispatch) => {
    dispatch({ type: 'CALL/SET_SELF_PARTICIPANT', payload: participant });
};
export const setParticipants = (participants) => (dispatch) => {
    dispatch({ type: 'CALL/SET_PARTICIPANTS', payload: participants });
};
export const pinStream = (streamId) => () => {
    const activeStreamService = getAngularService(AngularServices.ActiveStreamService);
    activeStreamService.pin(streamId);
};
export const updateVideoSubscriptions = (participants) => (_, getState) => {
    const activeStreamService = getAngularService(AngularServices.ActiveStreamService);
    const currentStreamId = getCurrentStreamId(getState());
    const visibleParticipantsCount = participants.length === VISIBLE_PARTICIPANTS_COUNT
        ? VISIBLE_PARTICIPANTS_COUNT
        : VISIBLE_PARTICIPANTS_COUNT - 1;
    for (const [index, participant] of participants.entries()) {
        const stream = activeStreamService.activeProvider.getStreamById(participant.id);
        const isNeededVideoSubscription = index < visibleParticipantsCount ||
            participant.id === currentStreamId ||
            participant.id === activeStreamService.getCurrentStreamId();
        if (stream instanceof TokboxMediaStream) {
            // @TODO remove this workaround when the issue with subscriber.subscribeToVideo is fixed on the Vonage side.
            // @description see https://doxyme.atlassian.net/browse/CS-7202
            //                  https://doxyme.atlassian.net/browse/CS-7216
            if (!Boolean(stream.videoElement)) {
                return;
            }
            stream.toggleVideoSubscription(isNeededVideoSubscription);
        }
    }
};
// User actions
export const changeCamera = (deviceId) => (dispatch) => {
    const rootScope = getAngularService(AngularServices.RootScope);
    rootScope.$emit(RootScopeEvents.USER_ACTIONS.CHANGE_CAMERA);
    dispatch(devices.actions.changeVideoDevice(deviceId));
};
export const changeMic = (deviceId) => (dispatch) => {
    const rootScope = getAngularService(AngularServices.RootScope);
    rootScope.$emit(RootScopeEvents.USER_ACTIONS.CHANGE_MIC);
    dispatch(devices.actions.changeAudioDevice(deviceId));
};
const endCallByPatient = (reason) => {
    const rootScope = getAngularService(AngularServices.RootScope);
    const communicationControl = getAngularService(AngularServices.CommunicationControl);
    rootScope.$emit(extensionIntegrEvents.PATIENT_ENDED_CALL);
    rootScope.$emit(RootScopeEvents.ACTIVE_PROVIDER.END_REASON, reason);
    communicationControl.phoneStop();
    rootScope.$emit(RootScopeEvents.REMOVE_CURRENT_PATIENT_FROM_WAITING_ROOM);
};
const endCallByProvider = (reason) => {
    const rootScope = getAngularService(AngularServices.RootScope);
    const communicationControl = getAngularService(AngularServices.CommunicationControl);
    rootScope.$emit(extensionIntegrEvents.DOCTOR_ENDED_CALL);
    rootScope.$emit(RootScopeEvents.ACTIVE_PROVIDER.END_REASON, reason);
    communicationControl.removeEveryoneOnCall();
};
export const endCallByUser = (reason) => () => {
    if (helpers.isPatient()) {
        endCallByPatient(reason);
    }
    else {
        endCallByProvider(reason);
    }
};
export const holdCall = () => () => {
    const communicationControl = getAngularService(AngularServices.CommunicationControl);
    communicationControl.phoneStop();
};
export const openCallSettings = (isPatient) => () => {
    const rootScope = getAngularService(AngularServices.RootScope);
    const modalsService = getAngularService(AngularServices.Modal);
    rootScope.$emit(RootScopeEvents.USER_ACTIONS.OPEN_VIDEO_SETTINGS);
    modalsService.open('videoSettings', {
        header: localeService.formatMessageById('video-settings.header-in-call'),
        isPatient: isPatient,
    });
};
export const onCallMenuOpen = () => () => {
    const $rootScope = getAngularService(AngularServices.RootScope);
    $rootScope.$emit(RootScopeEvents.USER_ACTIONS.OPEN_CALL_MENU);
};
export const openCallSettingsFromMenu = (isPatient) => (dispatch) => {
    dispatch(openCallSettings(isPatient));
};
export const addPublisherError = (publisherErrors, personId) => (dispatch) => {
    if (publisherErrors.has(personId)) {
        return;
    }
    const newErrorsSet = new Set(publisherErrors);
    newErrorsSet.add(personId);
    dispatch({ type: 'CALL/SET_PUBLISHER_ERRORS', payload: newErrorsSet });
};
export const removePublisherError = (publisherErrors, personId) => (dispatch) => {
    if (!publisherErrors.has(personId)) {
        return;
    }
    const newErrorsSet = new Set(publisherErrors);
    newErrorsSet.delete(personId);
    dispatch({ type: 'CALL/SET_PUBLISHER_ERRORS', payload: newErrorsSet });
};
export const addSelfPublisherError = (error) => (dispatch) => {
    dispatch({ type: 'CALL/ADD_SELF_PUBLISHER_ERROR', payload: error });
};
export const toggleSelfPublisherError = (isError) => (dispatch) => {
    dispatch({ type: 'CALL/SET_SELF_PUBLISHER_ERROR', payload: isError });
};
export const showSelfPublisherErrorToastProvider = () => (dispatch) => {
    const message = localeService.formatMessageById('video-chat.publisher-error.toast.provider');
    dispatch(coreActions.addToast(ToastType.warning, message));
};
export const showSelfPublisherErrorToastParticipant = () => (dispatch) => {
    const message = localeService.formatMessageById('video-chat.publisher-error.toast.participant');
    dispatch(coreActions.addToast(ToastType.warning, message));
};
export const restartCall = (reason) => () => {
    const communicationControl = getAngularService(AngularServices.CommunicationControl);
    const rootScope = getAngularService(AngularServices.RootScope);
    const modalsService = getAngularService(AngularServices.Modal);
    rootScope.$emit(RootScopeEvents.ACTIVE_PROVIDER.END_REASON, reason);
    modalsService.close();
    communicationControl.restartCall();
};
export const showSelfPreview = () => (dispatch) => {
    dispatch({ type: 'CALL/SHOW_SELF_PREVIEW' });
    const rootScope = getAngularService(AngularServices.RootScope);
    rootScope.$emit(RootScopeEvents.USER_ACTIONS.SHOW_PREVIEW);
    setLocalStorage(LocalStorageKeys.SELF_VIDEO_EXPANDED, 'true');
};
export const hideSelfPreview = () => (dispatch) => {
    dispatch({ type: 'CALL/HIDE_SELF_PREVIEW' });
    const rootScope = getAngularService(AngularServices.RootScope);
    rootScope.$emit(RootScopeEvents.USER_ACTIONS.HIDE_PREVIEW);
    setLocalStorage(LocalStorageKeys.SELF_VIDEO_EXPANDED, 'false');
    const globalUi = getAngularService(AngularServices.GlobalUi);
    if (globalUi.ui.pinnedStreamId === 'self') {
        globalUi.ui.pinnedStreamId = null;
    }
    if (globalUi.ui.activeStreamId === 'self') {
        globalUi.ui.activeStreamId = null;
    }
    const activeStreamService = getAngularService(AngularServices.ActiveStreamService);
    activeStreamService.setCurrentStreamByVolume();
};
export const initIsSelfPreviewVisible = () => (dispatch) => {
    if (getLocalStorage(LocalStorageKeys.SELF_VIDEO_EXPANDED) === 'false') {
        dispatch(hideSelfPreview());
    }
};
export const setBackgroundEffect = (effect) => (dispatch) => {
    dispatch({ type: 'CALL/SET_BACKGROUND_EFFECT', payload: effect });
    // Is the user using the branded logo effect?
    const hasBrandedVirtualBackground = effect.index === 2;
    // Add a new `hasBrandedVirtualBackground` field to the provider object
    const videoProviderFactory = getAngularService(AngularServices.VideoProviderFactory);
    videoProviderFactory.activeProvider.updateState({
        hasBrandedVirtualBackground,
    });
    const key = LocalStorageKeys.BACKGROUND_EFFECT;
    setLocalStorageValueForCurrentUser(key, effect.index.toString());
    const trackingFactory = getAngularService(AngularServices.TrackingFactory);
    trackingFactory.global.trackButtonClick({
        button_text: 'Apply background effect',
        button_action: effect.name,
    });
};
export const initBackgroundEffect = () => (dispatch) => {
    if (!canUseBackgroundEffects()) {
        return;
    }
    const key = LocalStorageKeys.BACKGROUND_EFFECT;
    const index = getLocalStorageValueForCurrentUser(key);
    const hasDefaultLogoHorizontal = getIsLogoHorizontalDefault();
    const hasBrandedVirtualBackground = Number(index) === BrandedVirtualBackground.index;
    /**
     *  Add a new `hasBrandedVirtualBackground` field to the provider object
     *  when the background is initial (e.g. starting the call)
     */
    const videoProviderFactory = getAngularService(AngularServices.VideoProviderFactory);
    videoProviderFactory.activeProvider.updateState({
        hasBrandedVirtualBackground,
    });
    const effects = getEffectsWithBrandedVirtualBackground();
    const hasBrandedVirtualBackgroundWithoutLogo = hasBrandedVirtualBackground && hasDefaultLogoHorizontal;
    const effect = effects.find((item) => item.index === Number(index));
    if (effect != null) {
        dispatch({ type: 'CALL/SET_BACKGROUND_EFFECT', payload: effect });
    }
    /**
     * If the institution has a branded virtual background, but no logo
     * we set the effect to the 2nd one (blur)
     */
    if (hasBrandedVirtualBackgroundWithoutLogo) {
        dispatch({ type: 'CALL/SET_BACKGROUND_EFFECT', payload: effects[1] });
    }
};
export const setIsPiPTurnedOn = () => (dispatch) => {
    dispatch({ type: 'CALL/SET_IS_PIP_TURNED_ON' });
};
export const setIsPiPTurnedOff = () => (dispatch) => {
    dispatch({ type: 'CALL/SET_IS_PIP_TURNED_OFF' });
};
export const togglePiP = () => async () => {
    const PiPService = getAngularService(AngularServices.PiPService);
    return PiPService.togglePiP();
};
export const setEndCallAttempt = () => (dispatch) => {
    dispatch({ type: 'CALL/SET_END_CALL_ATTEMPT', payload: true });
};
export const resetEndCallAttempt = () => (dispatch) => {
    dispatch({ type: 'CALL/SET_END_CALL_ATTEMPT', payload: false });
};
export const showPreviewsList = () => (dispatch) => {
    dispatch({ type: 'CALL/SHOW_PREVIEWS_LIST' });
};
export const hidePreviewsList = () => (dispatch) => {
    dispatch({ type: 'CALL/HIDE_PREVIEWS_LIST' });
};
export const setSelfPreviewLoading = (value) => (dispatch) => {
    dispatch({ type: 'CALL/SET_IS_SELF_PREVIEW_LOADING', payload: value });
};
export const cleanupCaptionsOnCallEnd = () => (dispatch, getState) => {
    const state = getState();
    const isCaptionsOpen = getIsCaptionsOpen(state);
    if (!isCaptionsOpen) {
        return;
    }
    dispatch(setIsClosedCaptionsOpen(false));
    dispatch(clearCaptions());
    /**
     * Clean up the captions usage map and calling the stopLiveCaptions API
     * when call has ended.
     */
    if (helpers.isDoctor()) {
        const closedCaptionsService = getAngularService(AngularServices.ClosedCaptionsService);
        closedCaptionsService.resetCaptions();
    }
};
